const state = {
    isResultActive: false,
    isTranslateActive: false,
    activeBidId: '',
    currentBid: {},
}

const getters = {
    getResultModalStatus: (state) => (lotId) => {
        return state.isResultActive && state.activeBidId === lotId
    },
    getTranslateModalStatus: (state) => (lotId) => {
        return state.isTranslateActive && state.activeBidId === lotId
    },
    getCurrentBidModalStatus: (state) => (bidId) => {
        return state.currentBid
    }
 }

const mutations = {
    setResultModalStatus: (state, newStatus) => {
        state.isResultActive = newStatus.status
        state.activeBidId = newStatus.bidId
    },
    setTranslateModalStatus: (state, newStatus) => {
        state.isTranslateActive = newStatus.status
        state.activeBidId = newStatus.bidId
    },
    toggleNegoStartPrice: (state, data) => {
        state.currentBid = {bidId: data.bidId, status: data.status}
    }
}

const actions = {
    changeResultModalStatus: ({ commit }, newStatus) => {
        commit('setResultModalStatus', newStatus)
    },
    changeTranslateModalStatus: ({ commit }, newStatus) => {
        commit('setTranslateModalStatus', newStatus)
    },
    toggleNegoStartPrice: ({ commit }, data) => {
        commit('toggleNegoStartPrice', data)
    }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/bidsModals.js